module.exports = __webpack_public_path__ + "img/gsc.506a9b83.svg";